import { useConfig } from '@borealis/huck/client';
import type { Config } from '../../types.js';

// useConfig is an instance of "icefog", which means it is _not_ a React hook. Due to its naming, it will be considered a hook by linters-
export const getHuckConfig = useConfig<Config>;
